import { storeOrUpdateCorporation } from '@/api/corporation'

export default {
    components: {
    },
    props: {
        showForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data () {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            loading: false,
            rules: {
                name: [ { required: true, message: '请输入主体名称', trigger: 'change' }],
            }
        }
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '添加'
        }
    },
    mounted () {
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            });
        },
        storeOrUpdate() {
            this.loading = true
            storeOrUpdateCorporation(this.model).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success(this.model.id > 0 ? '修改成功' : '添加成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showForm', false)
        }
    }
}
